import { Component } from '@angular/core';

import { DOC_TYPES, FoundDocument, REASONS, landscapeLabel } from '~/models/document-finder.models';
import { DocumentFinderService } from '~/services/document-finder.service';

@Component({
    selector: 'df-feedback-step',
    templateUrl: './df-feedback-step.component.html',
    styleUrls: ['./df-feedback-step.component.scss'],
    standalone: false
})
export class DfFeedbackStepComponent {
    public readonly reasons = REASONS;
    public readonly docTypes = DOC_TYPES as Record<string, (typeof DOC_TYPES)[keyof typeof DOC_TYPES]>;
    public readonly landscapeLabel = landscapeLabel;

    constructor(public df: DocumentFinderService) {}

    public readonly trackById = (_: number, d: FoundDocument) => d.id;

    public get excluded(): FoundDocument[] { return this.df.excluded(); }
    public get pending(): FoundDocument[] { return this.df.pending(); }

    public undo(id: string): void {
        this.df.include(id);
    }

    public setReason(id: string, reason: string): void {
        this.df.reasons[id] = reason;
    }

    public setWhy(id: string, value: string): void {
        this.df.whys[id] = value;
    }

    public addMissing(): void {
        this.df.openMissing();
    }

    public editMissing(i: number): void {
        this.df.openMissing(null, i);
    }

    public removeMissing(i: number): void {
        this.df.removeMissing(i);
    }

    public backToReview(): void {
        this.df.go(3);
    }
}
